import { css } from "@emotion/css";

export const Fields = ({
  pro12,
  openWomen123,
  cat3,
}: {
  pro12: string;
  openWomen123: string;
  cat3: string;
}) => (
  <div
    className={css`
      display: grid;
      width: 300px;
      grid-template-columns: 2fr 3fr;
      .field-name {
        margin-top: 5px;
        font-weight: 700;
      }
      .field-value {
      }
    `}
  >
    <div className="field-name">P-1-2</div>
    <div>{pro12}</div>
    <div className="field-name">O/W 1-2-3</div>
    <div>{openWomen123}</div>
    <div className="field-name">Cat3</div>
    <div>{cat3}</div>
  </div>
);
